import { LOCIZE_NS } from '@avanta/shared/constants/common';
import { AppointmentService } from '@avanta/shared/services/appointments';
import { type EditAppointmentPayload } from '@avanta/shared/types/appointments';
import { useMutation, type UseMutationResult, useQueryClient } from '@tanstack/react-query';
import { type AxiosError } from 'axios';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router';
import { toast } from 'sonner';
import { MUTATION_KEYS, QUERY_KEYS } from 'constants/common';
import { ROUTES } from 'constants/routes';

export const useEditAppointment = (): UseMutationResult<void, Error, EditAppointmentPayload> => {
  const queryClient = useQueryClient();
  const { t } = useTranslation(LOCIZE_NS.APPOINTMENTS);
  const navigate = useNavigate();

  return useMutation<void, AxiosError, EditAppointmentPayload>({
    mutationKey: [MUTATION_KEYS.UPDATE_APPOINTMENT],
    mutationFn: async (body: EditAppointmentPayload) => {
      await AppointmentService.edit(body);
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [QUERY_KEYS.FETCH_NEXT_APPOINTMENTS] });
      toast.success(t('EditAppointment.success'));
      navigate(ROUTES.APPOINTMENTS);
    },
    onError: error => {
      //TODO usar custom error code
      if (error?.status === 403) {
        toast.error(t('EditAppointment.error.forbidden'));
      } else {
        toast.error(t('EditAppointment.error.generic'));
      }
    },
  });
};
